// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2r6mA","productName":"Table_productName__2Zb_9"};